import WelcomeAgent from './agent/WelcomeAgent';
import WelcomeUser from './user/WelcomeUser';

function Welcome() {}

Welcome.Agent = WelcomeAgent;
Welcome.User = WelcomeUser;

export default Welcome;